import { Box } from "@mui/material";
import React, { useState } from "react";
import { MdOutlineRefresh } from "react-icons/md";
import { getShipmentDetails } from "../pages/Shipping/Integration/APIService";
import { useSelector } from "react-redux";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../firebaseConfig";
import { toast } from "react-toastify";
import Loader from "../assets/images/abc2.gif";

function SerialNumber({
  SerialNumber,
  packageTotalAmount,
  shipmentData,
  userClickHandler,
  pageName,
  reloadDetails,
}) {
  const userData = useSelector((state) => state.auth.value);

  const updateShipingLabel = async () => {
    const data1 = await getShipmentDetails(
      userData?.easyShipApikey,
      shipmentData?.easyshipShipmentId,
      "",
    );
    console.log(
      shipmentData?.easyshipShipmentId,
      data1,
      "data1data1data1data1",
    );

    if (data1?.shipment) {
      const docRef = doc(db, "shipments", shipmentData?.id);
      console.log(data1?.shipment?.shipping_documents, "asdsfxfsdf");
      updateDoc(docRef, {
        labelUrl:
          data1?.shipment?.shipping_documents?.find(
            (item) => item.category === "label",
          )?.url || "",
        customerDeclaration:
          data1?.shipment?.shipping_documents?.find(
            (item) => item.category === "commercial_invoice",
          )?.url || "",
        packing_slip:
          data1?.shipment?.shipping_documents?.find(
            (item) => item.category === "packing_slip",
          )?.url || "",
      }).then(() => {
        const label =
          data1?.shipment?.shipping_documents?.find(
            (item) => item.category === "label",
          )?.url || "";
        const label1 =
          data1?.shipment?.shipping_documents?.find(
            (item) => item.category === "commercial_invoice",
          )?.url || "";
        const label2 =
          data1?.shipment?.shipping_documents?.find(
            (item) => item.category === "packing_slip",
          )?.url || "";
        label
          ? toast.success("Shipping Label Updated Successfully !")
          : toast.error("Shipping Label is not ready yet !");
        reloadDetails({
          labelUrl: label,
          customerDeclaration: label1,
          packing_slip: label2,
        });
      });
    }
  };
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        margin: "20px",
        marginRight: "0px",
        backgroundColor: "#F9FAFC",
        border: "1px solid #E5E5E8",
        paddingY: "20px",
        paddingX: "40px",
        borderRadius: "4px",
      }}
    >
      <Box sx={{ display: "grid" }}>
        <label
          style={{
            color: "#959BA1",
            fontWeight: "500",
            fontSize: "14px",
          }}
        >
          Serial Number
        </label>
        <label
          style={{
            color: "#1C2630",
            fontWeight: "bold",
            fontSize: "16px",
          }}
        >
          {SerialNumber}
        </label>
      </Box>
      {pageName === "shippingComplete" && (
        <Box sx={{ display: "grid" }}>
          <label
            style={{
              color: "#959BA1",
              fontWeight: "500",
              fontSize: "14px",
            }}
          >
            EasyShip Shipment Id
          </label>
          <label
            className="flex items-center justify-center"
            style={{
              color: "#000",
              fontWeight: "bold",
              fontSize: "16px",
            }}
          >
            {shipmentData?.easyshipShipmentId}
            {!shipmentData?.labelUrl && (
              <MdOutlineRefresh
                className="w-5 h-5 ms-2 text-black cursor-pointer"
                onClick={() => {
                  updateShipingLabel();
                }}
              />
            )}
            {/* <img src={Loader} style={{width:"30px",height:"30px"}}/> */}
          </label>
        </Box>
      )}
      <Box sx={{ display: "grid" }}>
        <label
          style={{
            color: "#959BA1",
            fontWeight: "500",
            fontSize: "14px",
          }}
        >
          Value
        </label>
        <label
          style={{
            color: "#1C2630",
            fontWeight: "bold",
            fontSize: "16px",
          }}
        >
          ${packageTotalAmount?.toFixed(2)}
        </label>
      </Box>
    </Box>
  );
}

export default SerialNumber;
